var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"wishlist-modal-icon small-icons heart-icon",class:[_vm.wishlistIcon ? 'active' : ''],attrs:{"title":_vm.title},on:{"click":function($event){return _vm.openModalMethod()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }